import { useFilterPreferences } from '@/shared/features/filter-preferences/hooks/use-filter-preferences/use-filter-preferences';
import { TResetTableViews } from '@/shared/features/filter-preferences/hooks/use-reset-table-views/use-reset-table-views.types';
import {
  clearAllTableViews,
  hasAnyTableView,
} from '@/shared/features/filter-preferences/storage/table-state-storage/table-state-storage';
import { selectUser } from '@/shared/redux/api/auth/auth-api';
import { useAppSelector } from '@/shared/redux/hooks/hooks';

// Table state only, current tenant only: theme, language and the rest are one
// click each and stay put.
export const useResetTableViews = (): TResetTableViews => {
  const user = useAppSelector(selectUser);
  const tenantId = user?.attributes?.['custom:tenantId'] ?? '';
  const { hasAnyStoredView, resetScopeViews } = useFilterPreferences();

  return {
    hasCustomViews: hasAnyTableView(tenantId) || hasAnyStoredView(),
    // Saved views first: that write can fail, and the local ones are worth keeping.
    resetTableViews: async () => {
      await resetScopeViews();
      clearAllTableViews(tenantId);
    },
  };
};
